import {
  IconBolt,
  IconUserPlus,
  IconFolderPlus,
  IconDownload,
  IconSettings,
} from "@tabler/icons-react";
import styles from "../../pages/ClientDashboard/TeamManagement/teamManagement.module.css";

export default function QuickActionsCard({
  onInviteUser,
  onCreateTeam,
  canWrite,
}) {
  return (
    <div className={styles.sidebarCard}>
      <div className={styles.sidebarCardHeader}>
        <IconBolt size={17} />
        <span className={styles.sidebarCardTitle}>Quick Actions</span>
      </div>
      <div
        className={`${styles.sidebarCardBody} ${styles.sidebarCardBodyTight}`}
      >
        {canWrite && (
          <>
            <button className={styles.quickLink} onClick={onInviteUser}>
              <IconUserPlus size={17} /> Invite a new user
            </button>
            <button className={styles.quickLink} onClick={onCreateTeam}>
              <IconFolderPlus size={17} /> Create a new team
            </button>
          </>
        )}
        {/*
					Both left as-is — not part of the documented API surface.
					"Export members list" would need its own endpoint or a
					client-side CSV built from the `users` already fetched;
					"Permission settings" doesn't correspond to anything in
					this doc (roles are fixed to the four documented tiers).
				*/}
        <a href="#" className={styles.quickLink}>
          <IconDownload size={17} /> Export members list
        </a>
        <a href="#" className={styles.quickLink}>
          <IconSettings size={17} /> Permission settings
        </a>
      </div>
    </div>
  );
}
